// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: contents;
}
:host .kpi {
  width: var(--boxx-kpi-width, unset);
  min-width: var(--boxx-kpi-min-width, 39%);
  max-width: var(--boxx-kpi-max-width, 100%);
  height: var(--boxx-kpi-height, unset);
  min-height: var(--boxx-kpi-min-height, 108px);
  max-height: var(--boxx-kpi-max-height, 300px);
  padding: var(--boxx-kpi-padding, 20px);
  border-radius: var(--boxx-kpi-border-radius, 8px);
  background-color: var(--boxx-kpi-background, white);
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(5px);
  text-align: center;
  position: relative;
  display: grid;
  margin: 16px;
}
:host .kpi .kpi-label {
  color: #0C2340;
  text-align: center;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
}
:host .kpi .kpi-counter {
  color: #0C2340;
  text-align: center;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 34px;
  margin-left: var(--boxx-kpi-counter-margin-left, 20px);
}
:host .secondary-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.special-ventasclick {
  background: #34495e !important;
}
.special-ventasclick .kpi-label {
  color: #ffffff !important;
}
.special-ventasclick .kpi-counter .value {
  color: #ffffff !important;
}

@media (min-width: 960px) {
  #kpi:first-child {
    margin-bottom: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/modules/@boxx/panel-core/lib/components/kpi-item/kpi-item.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;AACF;AACE;EACE,mCAAA;EACA,yCAAA;EACA,0CAAA;EACA,qCAAA;EACA,6CAAA;EACA,6CAAA;EAEA,sCAAA;EACA,iDAAA;EACA,mDAAA;EACA,0CAAA;EAEA,0BAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;AAAJ;AAEI;EAKE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAJN;AAMI;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EAIA,sDAAA;AAPN;AAWE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AATJ;;AAaA;EACE,8BAAA;AAVF;AAYE;EACE,yBAAA;AAVJ;AAaE;EACE,yBAAA;AAXJ;;AAwBA;EACE;IACE,mBAAA;EArBF;AACF","sourcesContent":[":host {\n  display: contents;\n\n  .kpi {\n    width: var(--boxx-kpi-width, unset);\n    min-width: var(--boxx-kpi-min-width, 39%);\n    max-width: var(--boxx-kpi-max-width, 100%);\n    height: var(--boxx-kpi-height, unset);\n    min-height: var(--boxx-kpi-min-height, 108px);\n    max-height: var(--boxx-kpi-max-height, 300px);\n    //margin: var(--boxx-kpi-margin, inherit);\n    padding: var(--boxx-kpi-padding, 20px);\n    border-radius: var(--boxx-kpi-border-radius, 8px);\n    background-color: var(--boxx-kpi-background, white);\n    background-color: rgba(255, 255, 255, 0.8);\n    -webkit-backdrop-filter: blur(5px);\n    backdrop-filter: blur(5px);\n    text-align: center;\n    position: relative;\n    display: grid;\n    margin: 16px;\n\n    .kpi-label {\n      // color: var(--boxx-kpi-label-color, var(--ion-text-color));\n      // font-size: var(--boxx-kpi-label-font-size, 15px);\n      // font-weight: var(--boxx-kpi-label-font-weight, 500);\n\n      color: #0C2340;\n      text-align: center;\n      font-size: 17px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 22px;\n    }\n    .kpi-counter {\n      color: #0C2340;\n      text-align: center;\n      font-size: 24px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: 34px;\n      // color: var(--boxx-kpi-counter-color, var(--ion-text-color));\n      // font-size: var(--boxx-kpi-counter-font-size, 36px);\n      // font-weight: var(--boxx-kpi-counter-font-weight, 500);\n      margin-left: var(--boxx-kpi-counter-margin-left, 20px);\n    }\n  }\n\n  .secondary-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n}\n\n.special-ventasclick{\n  background: #34495e !important;\n\n  .kpi-label{\n    color: #ffffff !important;\n  }\n\n  .kpi-counter .value{\n    color: #ffffff !important;\n  }\n}\n\n.special-getnet{\n}\n\n.special-boxx{\n}\n\n\n\n//PWA\n@media (min-width: 960px) {\n  #kpi:first-child {\n    margin-bottom: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
